<template>
  <div class="goods-item" @click="$router.push(`/prodetail/${item.goods_id}`)">
    <div class="left">
      <img :src="item.goods_image" alt="">
      <span class="group-flag" v-if="item.is_group_buy">拼单 ¥{{ item.group_price }}</span>
    </div>
    <div class="right">
      <p class="tit text-ellipsis-2"> {{ item.goods_name }} </p>
      <p class="count">已售{{ item.goods_sales }}件</p>
      <p class="price">
        <span class="new">¥{{ item.goods_price_min }}</span>
        <span class="old">¥{{ item.goods_price_max }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GoodsItem',
  props: {
    // 商品信息
    item: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="less" scoped>
.goods-item {
  height: 148px;
  margin-bottom: 6px;
  padding: 10px;
  background-color: #fff;
  display: flex;

  .left {
    position: relative;
    width: 127px;

    img {
      display: block;
      width: 100%;
    }

    .group-flag {
      position: absolute;
      left: 0;
      bottom: 0;
      background: linear-gradient(90deg, #ff6b35, #ff8c42);
      color: #fff;
      font-size: 11px;
      padding: 2px 8px;
      border-radius: 0 4px 0 0;
    }
  }

  .right {
    flex: 1;
    font-size: 14px;
    line-height: 1.3;
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;

    .count {
      color: #999;
      font-size: 12px;
    }

    .price {
      color: #999;
      font-size: 16px;

      .new {
        color: #ff6b35;
        margin-right: 10px;
      }

      .old {
        text-decoration: line-through;
        font-size: 12px;
      }
    }
  }
}
</style>
